import React from 'react';
import { useNavigate } from 'react-router-dom';
import { MapPin, MessageCircle, TrendingUp } from 'lucide-react';
import { User } from '../types';
import { ROUTES } from '../constants/app';

interface HeaderProps {
  location: string;
  userType?: 'entrepreneur' | 'investor';
  currentUser: User;
}

export const Header: React.FC<HeaderProps> = ({ 
  location, 
  userType = 'entrepreneur',
  currentUser
}) => {
  const navigate = useNavigate();

  const handleProfileClick = () => {
    navigate(ROUTES.PROFILE);
  };

  const handleConversationsClick = () => {
    navigate(ROUTES.CONVERSATIONS);
  };

  return (
    <header className="flex items-center justify-between gap-3 px-4 py-3 bg-white border-b border-gray-100 flex-shrink-0">
      <div className="flex items-center gap-3 flex-shrink-0">
        <div className="flex items-center justify-center bg-white p-3 rounded-full border border-platinum shadow-sm">
          <img 
            src="/Logo principal negro.svg" 
            alt="RacksMatch Logo" 
            className="w-8 h-8"
          />
        </div>
        
        {/* User Avatar */}
        <button
          onClick={handleProfileClick}
          className="relative group"
          aria-label="Ver perfil"
        >
          <img
            src={currentUser.images[0]}
            alt={`${currentUser.name} avatar`}
            className="w-10 h-10 rounded-full object-cover object-center border-2 border-white shadow-sm group-hover:border-blue-300 transition-all duration-200 group-hover:scale-105"
          />
          <div className="absolute inset-0 rounded-full bg-black bg-opacity-0 group-hover:bg-opacity-10 transition-all duration-200" />
        </button>
      </div>
      
      <div className="flex items-center gap-2 min-w-0 flex-1 justify-center">
        <MapPin className="w-5 h-5 text-slate_gray" />
        <span className="text-outer_space font-medium text-sm truncate">{location}</span>
      </div>
      
      <div className="flex items-center gap-3 flex-shrink-0">
        <span className="text-xs text-slate_gray bg-anti_flash_white px-2 py-1 rounded-full whitespace-nowrap">
          {userType === 'entrepreneur' ? 'Finding Investors' : 'Finding Startups'}
        </span>
        <button
          onClick={handleConversationsClick}
          className="p-1.5 rounded-full hover:bg-anti_flash_white transition-colors duration-200 relative"
        >
          <MessageCircle className="w-5 h-5 text-slate_gray" />
        </button>
      </div>
    </header>
  );
};